import {useSelector} from 'react-redux'
import {InsightsResponse} from '@findhotel/sapi/dist/types/packages/core/src/insights'
import {getLanguageCode} from 'modules/meta/selectors'
import {useTranslateInsightsQuery} from 'modules/translateInsightsApi'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

export const useAiPoweredInsight = (
  hotelId: string
): {data: InsightsResponse; isLoading: boolean; isEnabled: boolean} => {
  const toggle = useToggle()
  const lang = useSelector(getLanguageCode)

  const {data, isLoading} = useTranslateInsightsQuery(
    {hotelId, lang},
    {skip: toggle('feature-translate-insights', true, !hotelId || !lang)}
  )

  return {
    data,
    isLoading,
    isEnabled: Boolean(data?.overall || isLoading)
  }
}
